module.exports = __webpack_public_path__ + "media/Video 75.f1c17902.mp4";